import * as React from 'react';
import { SVGProps } from 'react';

const IconArrowDownSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 9.593 3.703 5.296 2.289 6.71 8 12.421l5.711-5.711-1.414-1.414L8 9.593Z"
    />
  </svg>
);
export default IconArrowDownSizeS;
